import axios from 'axios';

const API = axios.create({
  // Standardizes the API URL for Create React App
  baseURL: process.env.REACT_APP_API_URL || 'https://syntexhub-blog-app.onrender.com/api',
});

// Set default timeout to handle Render "cold starts" (spins up after 15 mins inactivity)
API.defaults.timeout = 60000; 

// Automatically attach the JWT token to every request if it exists
API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

export default API;